import { useState, useEffect } from "react";
import { jwtDecode } from "@/utils/helper";
import { getFromLocalStorage } from "@/utils/indexDBStorage";

type TokenData = ReturnType<typeof jwtDecode>;

export function useTokenData(): TokenData | null {
  const [tokenData, setTokenData] = useState<TokenData | null>(null);

  useEffect(() => {
    (async () => {
      const token = await getFromLocalStorage("token");
      if (token && typeof token === "string") {
        const data = jwtDecode(token);
        setTokenData(data);
      }
    })();
  }, []);

  return tokenData;
}
